var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BANK_INFORMATION_TRANSLATIONS } from './bankInformationTranslations';
import { BOARD_TRANSLATIONS } from './boardTranslations';
import { COMMON_TRANSLATIONS } from './commonTranslations';
import { DELIVERY_METHOD_TRANSLATION } from './deliveryMethodTranslation';
import { DOCUMENTS_TRANSLATIONS } from './documentsTranslations';
import { LOGO_COVER_TRANSLATIONS } from './logoCoverTranslations';
import { SCHEDULES_TRANSLATIONS } from './schedulesTranslations';
import { SOCIAL_REASON_TRANSLATIONS } from './socialReasonTranslations';
import { VALIDATE_CONTACT } from './validateContactTranslations';
export var TRANSLATIONS_ES = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({ welcome: 'Bienvenido!' }, COMMON_TRANSLATIONS), BOARD_TRANSLATIONS), SCHEDULES_TRANSLATIONS), DOCUMENTS_TRANSLATIONS), LOGO_COVER_TRANSLATIONS), BANK_INFORMATION_TRANSLATIONS), SOCIAL_REASON_TRANSLATIONS), DELIVERY_METHOD_TRANSLATION), VALIDATE_CONTACT);
